app.mediator.registerModule(MODULE_NAME__GALLERY_TITLE_BAR, function (app) {

    var $rootElem;

    function getSearchInput() {
        return $rootElem.find('.search-term-input');
    }

    function getSearchValue() {
        return getSearchInput().val();
    }

    var broadcastFilterData = app.helpers.funcs.debouncer(function(galleryFocusRequested, options) {
        options = typeof options !== 'undefined' ? options : {};
        options.broadcastingDueTo = typeof options.broadcastingDueTo !== 'undefined' ? options.broadcastingDueTo : 'generalFilterChange';
        app.mediator.notify(EVENT_NAME__GALLERY_TITLE_BAR__NEW_FILTER_DATA_APPLIED, {
            filterData: {
                searchTerm: getSearchValue()
            },
            broadcastingDueTo: options.broadcastingDueTo,
            galleryFocusRequested: galleryFocusRequested
        });
    }, 300, false);

    return {
        $rootElem: null,
        $searchTermInput: null,

        ignoreKeys: [
            17, // CTRL
            18, // ALT / ALTGR
            16, // SHIFT
            9, // TAB
            27, // ESC
            93, // OPENDIALOG
            19, // BREAK
            33, // PGUP
            34, // PGDOWN
            36, // HOME
            35, // END
            38, // UP
            40, // DOWN
            37, // LEFT
            39, // RIGHT
            20, // CAPSLOCK
            144, // NUMLOCK
            145, // SCROLLLOCK
            112, // F1
            113, // F2
            114, // F3
            115, // F4
            116, // F5
            117, // F6
            118, // F7
            119, // F8
            120, // F9
            121, // F10
            122, // F11
            123, // F12
        ],

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function(data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function() {

            $rootElem = $('.mod-search-filters-couplet');
            if (!$rootElem.length) return;

            this.addDomListeners();
            this.addMediatorListeners();

            app.mediator.notify(EVENT_NAME__GALLERY_TITLE_BAR__INITIATED);
        },

        deinit: function() {

        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function() {
            var scope = this;

            $rootElem.find('.toggle-filters-btn').click(function() {
                app.mediator.notify(EVENT_NAME__GALLERY_TITLE_BAR__OPEN_FILTERS_BUTTON_CLICKED);
            });

            $rootElem.find('.search-btn').click(function() {
                broadcastFilterData(true);
            });

            var oldTextValue;
            getSearchInput().keyup(function(e) {

                var newTextValue = getSearchValue();
                if ($.inArray(e.which, scope.ignoreKeys) > -1) return;
                if (newTextValue == oldTextValue) return;
                oldTextValue = getSearchValue();

                if (e.keyCode === 13) {
                    broadcastFilterData(true);
                } else {
                    broadcastFilterData(false);
                }
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function() {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED, function (data) {
                if (data.filterDataUpdateDueTo === 'filterClear') {
                    getSearchInput().val('');
                    broadcastFilterData();
                }
            });

            app.mediator.addListener(EVENT_NAME__GALLERY__FILTER_DATA_RESTORED, function(data) {
                getSearchInput().val(data.restoredFilterData.text);
                broadcastFilterData(true, {
                    broadcastingDueTo: 'filterRestore'
                });
            });

        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        broadcastFilterData: broadcastFilterData,
        getSearchValue: getSearchValue
    };
});